import { FC, Fragment } from "react";
import { DescriptionItemTittleCart } from "../atoms/DescriptionItemTittleCart";
import { DescriptionItemCart } from "../atoms/DescriptionItemCart";

export type DescriptionListCartProps = {
  total: number;
  currency: string;
};

export const DescriptionListCart: FC<DescriptionListCartProps> = ({
  currency,
  total,
}) => {
  return (
    <Fragment>
      <dl className="space-y-6 border-t border-gray-200 px-4 py-6 sm:px-6">
        <div className="flex items-center justify-between pt-6">
          <DescriptionItemTittleCart text="Total" />
          <DescriptionItemCart
            text={`${currency?.toUpperCase()} ${parseFloat(total + "").toFixed(2)}`}
          />
        </div>
      </dl>
    </Fragment>
  );
};
